module.exports = __webpack_public_path__ + "img/Weapon_165.7e849688.png";